export const CATEGORY_LOADING_TEST_ID = 'CATEGORY_LOADING_TEST_ID';
export const CATEGORY_PRODUCTS_LOADING_TEST_ID = 'CATEGORY_PRODUCTS_LOADING_TEST_ID';
